import { EntityType, EntityTypeDetail } from '@/entities/entityType';

export function intoEditable(data: EntityTypeDetail): EntityType {
  return {
    ...data.data,
  };
}
